export const TransferType = {
  STANDARD: {value: 'standard', label: 'Standard'},
  SAME_DAY: {value: 'same-day', label: 'Same Day'},
};
